import axiosInstance from '../api/axiosInstance';

/**
 * portLoadingService — Port of Loading / Origin API calls
 *
 *  GET    /portloading   → list all origins
 *  POST   /portloading   → create a new origin
 */

// Fetch all port-loading origins
export const getPortLoadings = () => {
  return axiosInstance.get('/portloading').then((res) => res.data);
};

// Create a new origin
export const createPortLoading = (data) => {
  return axiosInstance.post('/portloading', data).then((res) => res.data);
};
